import React from 'react';
import { DeleteLaboratories } from './DeleteLaboratories';
import { FormLaboratories } from './FormLaboratories';
import { Dialog } from 'primereact/dialog';
import { Button } from 'reactstrap'


export const ModalLaboratories = (props) => {

    const {
        modal, toggle, modalTitle, method, loading,
        handleInputChange, validaciones,
        id_external_laboratory, id_state, id_municipality, name_state, name_municipality, code,
        name, business_name, rfc, phone, address, colony, cp, email, web_site,
        saveCreate, saveUpdate, saveDelete,
        states, municipalities, handleChangeState, closeModaLaboratories
    } = props;


    return (


        <Dialog
            visible={modal}
            onHide={closeModaLaboratories}
            modal
            closable={true}
            dismissableMask={false}
            className={`${method === "delete" ? "medium-dialog delete-method" : "large-dialog"}`}
            header={modalTitle}
            blockScroll={true}
            footer={
                <>
                    {
                        method === "create" && <Button
                            size="sm"
                            color="secondary"
                            type="button"
                            onClick={saveCreate}
                            disabled={loading}
                        >
                            {loading ? "Guardando" ?? "--" : "Guardar" ?? "---"}
                        </Button>
                    }
                    {
                        method === "update" && <Button
                            size="sm"
                            color="secondary"
                            type="button"
                            onClick={saveUpdate}
                            disabled={loading}
                        >
                            {loading ? "Actualizar" ?? "--" : "Actualizar" ?? "---"}
                        </Button>
                    }
                    {
                        (method !== "update" && method !== "create") && <Button
                            size="sm"
                            color="secondary"
                            type="button"
                            onClick={saveDelete}
                            disabled={loading}
                        >
                            {loading ? "Eliminando..." : "Sí, eliminar"}
                        </Button>

                    }

                    <Button
                        size="sm"
                        color="danger"
                        type="button"
                        onClick={closeModaLaboratories}
                        disabled={loading}
                    >
                        Cancelar
                    </Button>
                </>
            } closeModaLaboratories
        >
            {
                method === "create"
                    ? <FormLaboratories
                        button="Guardar"
                        {...{ toggle, loading, handleInputChange, validaciones, methodAction: saveCreate, states, municipalities, handleChangeState, closeModaLaboratories }}
                    />
                    : (method === "update")

                        ?
                        <FormLaboratories
                            button="Actualizar"
                            {...{
                                toggle, loading, handleInputChange, validaciones,
                                id_external_laboratory, id_state, id_municipality, name_state, name_municipality, code,
                                name, business_name, rfc, phone, address, colony, cp, email, web_site, methodAction: saveUpdate,
                                states, municipalities, handleChangeState, closeModaLaboratories
                            }}
                        />
                        :
                        <DeleteLaboratories
                            {...{ toggle, loading, saveDelete, name, code, closeModaLaboratories }}
                        />


            }
        </Dialog>
    )
}
